// extracted by mini-css-extract-plugin
export default {"moveArrow":"MoveArrow_moveArrow__4HLx1","suggestion":"MoveArrow_suggestion__PAoEw","hint":"MoveArrow_hint__PepMD","pulse":"MoveArrow_pulse__fa2yk"};